"use client";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useCallback, useEffect } from "react";
const useAwaitableNavigate = () => {
  const { push } = useRouter();
  const pathname = usePathname();
  const params = useSearchParams();
  const urlKey = pathname + params.toString();
  useEffect(() => {
    window.__clerk_nav_ref = (to) => {
      if (to === window.location.href.replace(window.location.origin, "")) {
        push(to);
        return Promise.resolve();
      }
      return new Promise((res) => {
        if (window.__clerk_nav_resolves_ref) {
          window.__clerk_nav_resolves_ref.push(res);
        } else {
          window.__clerk_nav_resolves_ref = [res];
        }
        push(to);
      });
    };
  }, [urlKey]);
  useEffect(() => {
    if (window.__clerk_nav_resolves_ref && window.__clerk_nav_resolves_ref.length) {
      window.__clerk_nav_resolves_ref.forEach((resolve) => resolve());
    }
    window.__clerk_nav_resolves_ref = [];
  });
  return useCallback((to) => {
    return window.__clerk_nav_ref(to);
  }, []);
};
export {
  useAwaitableNavigate
};
//# sourceMappingURL=useAwaitableNavigate.js.map